// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"bf83b2f6","470":"0b25ab37","588":"baf90d7c","604":"8c1d7602","680":"fad2e9e8","834":"e29dc252","871":"ad8f560f","896":"3a122682","973":"ae22ba64"}[chunkId] + ".chunk.js";
};